import actions from './actions'
import {nextState, upload, uploadPrepare} from '../helper'

let initState = {
	single: {},
	loading: false,
	total: 0,
	params: {
		query: '',
		limit: 50,
		skip: 0,
	},
	data: []
}

export default function filmReducer(state = initState, action) {

	const {type, payload} = action

	switch (type) {
		/*case '@@router/LOCATION_CHANGE':
			console.log('--@@router/LOCATION_CHANGE--', payload)
			return state*/

		case actions.LOAD_FILM_SUCCESS:
			return {
				...state,
				single: payload
			}

		case actions.CHANGE_FILM:
			return nextState({
				...state,
				single: {
					...state.single,
					...payload
				}
			})

		case actions.RESET_FILM:
			return {
				...state,
				single: {}
			}



		case actions.SEARCH_FILM_PARAMS:
			return {
				...state,
				params: {
					...state.params,
					...payload
				}
			}

		case actions.SEARCH_FILM_SUCCESS:
			return {
				...state,
				total: payload.total,
				data: payload.data
			}



		case actions.UPLOAD_FILM:
			return nextState({
				...state,
				single: uploadPrepare(state.single, payload)
			})

		case actions.UPLOAD_FILM_SUCCESS:
			return nextState({
				...state,
				single: upload(state.single, payload)
			})

		case actions.REMOVE_FILM:
			return {
				...state,
				data: state.data.filter(rec => rec._id !== payload)
			}

		default:
			return state
	}
}
